import _ from 'lodash';
import { FETCH_COUNTRIES, FETCH_COUNTRY_STATES } from 'actions/types';

export default function(state = null, action) {
  switch (action.type) {
    case FETCH_COUNTRIES:
      return { ...state, list: action.payload };
    case FETCH_COUNTRY_STATES:
      const states = _.isEmpty(action.payload) ? null : action.payload;
      return { ...state, states };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/countries.js